import React, { useState } from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { Sidebar, MobileHeader } from './Sidebar';
import { useApp } from '../../context/AppContext';
import tokenManager from '../../utils/tokenManager';
import BillingBanner from './BillingBanner';

// Pages that fully support dark mode. Other pages keep light content
// (the sidebar still follows the theme) until they are converted.
const THEMED_ROUTES = ['/', '/dashboard', '/requests', '/calendar', '/team', '/settings'];

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Subscribing to the context re-renders this guard whenever auth state
  // changes (login, logout, session expiry).
  const { loadingUser } = useApp();

  // Still working out whether the saved session is usable
  if (loadingUser) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: 'var(--bg)',
        color: 'var(--text-muted)', fontSize: 14,
      }}>
        Loading…
      </div>
    );
  }

  // No session (never logged in, logged out, or expired) → login page.
  // Never render the protected pages without a user.
  if (!tokenManager.hasSession()) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg)' }}>

      {/* Sidebar — static on desktop, drawer on mobile/tablet */}
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content area */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: '100vh' }}>

        {/* Mobile top header — hidden on desktop (renders null itself) */}
        <MobileHeader onMenuOpen={() => setSidebarOpen(true)} />

        {/* Page content */}
        <main
          data-theme={THEMED_ROUTES.includes(location.pathname) ? undefined : 'light'}
          style={{
          flex: 1,
          background: 'var(--bg)',
          color: 'var(--text)',
          padding: 'clamp(12px, 3vw, 24px)',
          // Extra bottom padding on mobile so content isn't hidden behind bottom nav
          paddingBottom: 'max(clamp(12px, 3vw, 24px), calc(60px + env(safe-area-inset-bottom)))',
          overflowX: 'hidden',
        }}>
          <BillingBanner />
          <Outlet />
        </main>
      </div>
    </div>
  );
}